import React from "react";
import SpecialityFormPage from "../components/specialities/SpecialityFormPage";

const SpecialityEdit = () => <SpecialityFormPage mode="edit" />;

export default SpecialityEdit;
